var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.89 1.534 3.208 6.177a.373.373 0 0 1-.527 0L.11 3.63a.365.365 0 0 1 0-.523l.908-.903a.387.387 0 0 1 .527 0l1.399 1.387L6.454.108a.374.374 0 0 1 .528 0l.908.903a.365.365 0 0 1 0 .523Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallCheckmark);
export default __webpack_public_path__ + "static/media/smallCheckmark.6f457d6212d4e39820d382395384a95c.svg";
export { ForwardRef as ReactComponent };